import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../GlobalContext';
import { Link, useNavigate, useParams } from 'react-router-dom';

export default function TeamMember() {
  const navigate = useNavigate();
  const { cid, sid } = useParams();
  const { alert, setLoading } = useContext(GlobalContext);

  const [sportName, setSportName] = useState('');
  const [members, setMembers] = useState([]);
  const [inTeamCount, setInTeamCount] = useState(0);
  const [minLt, setMinLt] = useState(0);
  const [maxLt, setMaxLt] = useState(0);

  useEffect(() => {
    setLoading(true);
    (async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/team/members/${cid}/${sid}`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('auth'),
        },
      });
      const { data, error } = await res.json();
      if (res.ok) {
        const { players, sportName, minLt, maxLt } = data;
        setMembers(players);
        setInTeamCount(players.reduce((c, p) => c + p.inTeam, 0));
        setSportName(sportName);
        setMinLt(minLt);
        setMaxLt(maxLt);
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    })()
      .catch((error) => alert({ type: 'danger', title: 'Error !', text: error.message }))
      .finally(() => setLoading(false));
  }, [alert, cid, sid, setLoading]);

  const addPlayer = async (pid) => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/team/members/add/${cid}/${sid}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('auth'),
        },
        body: JSON.stringify({ pid }),
      });
      const { data, error } = await res.json();
      if (res.ok) {
        setMembers(members.map((mem) => (mem._id === pid ? { ...mem, inTeam: true } : mem)));
        setInTeamCount((tc) => tc + 1);
        alert({ type: 'success', title: 'Success !', text: data });
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    } catch (error) {
      alert({ type: 'danger', title: 'Error !', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  const removePlayer = async (pid) => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/team/members/remove/${cid}/${sid}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('auth'),
        },
        body: JSON.stringify({ pid }),
      });
      const { data, error } = await res.json();
      if (res.ok) {
        setMembers(members.map((mem) => (mem._id === pid ? { ...mem, inTeam: false } : mem)));
        setInTeamCount((tc) => tc - 1);
        alert({ type: 'success', title: 'Success !', text: data });
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    } catch (error) {
      alert({ type: 'danger', title: 'Error !', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  const submitTeam = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/team/submit/${cid}/${sid}`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('auth'),
        },
      });
      const { data, error } = await res.json();
      if (res.ok) {
        navigate(`/create-team/${cid}`);
        alert({ type: 'success', title: 'Success !', text: data });
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    } catch (error) {
      alert({ type: 'danger', title: 'Error !', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-body">
      <div className="container-xl">
        <div className="row row-cards">
          <div className="card my-3">
            <div className="card-header flex-column align-items-center">
              <h2 className="page-title">{sportName} Team Members</h2>
              <div>
                Minimum = {minLt} & Maximum = {maxLt}
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-vcenter card-table table-striped">
                <thead>
                  <tr>
                    <th>Details</th>
                    <th className="w-1">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {members.map((cp) => (
                    <tr key={cp._id}>
                      <td>
                        <ul className="list-unstyled lh-lg">
                          <li>Name: {cp.name}</li>
                          <li>Email: {cp.email}</li>
                          <li>Phone: {cp.phone}</li>
                          <li>JITO Youth Member: {cp.jitoYouthMember}</li>
                        </ul>
                      </td>
                      <td className="w-1">
                        <div className="btn-list flex-nowrap">
                          {cp.inTeam ? (
                            <button
                              className="btn btn-danger"
                              onClick={() => removePlayer(cp._id)}>
                              Remove
                            </button>
                          ) : (
                            <button
                              className="btn btn-success"
                              onClick={() => addPlayer(cp._id)}>
                              Add
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="card-footer text-center">
              <Link
                to={`/create-team/${cid}`}
                className="btn btn-secondary mx-1">
                Back
              </Link>
              <button
                className="btn btn-success mx-1"
                onClick={submitTeam}
                disabled={minLt > inTeamCount || maxLt < inTeamCount}>
                Submit Team
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
